import React, { useState } from 'react';
import { UserIcon } from 'lucide-react';
import UserProfile from './UserProfile';

/**
 * ClickableUser component - displays username and opens profile modal when clicked
 * 
 * @param {Object} props - Component props
 * @param {string} props.userId - User ID
 * @param {string} props.username - Username to display
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.showIcon - Whether to show user icon
 */
const ClickableUser = ({ userId, username, className = '', showIcon = true }) => {
  const [profileOpen, setProfileOpen] = useState(false);

  if (!userId || !username) {
    return <span className={className}>Unknown User</span>;
  }

  return (
    <>
      <button
        onClick={() => setProfileOpen(true)}
        className={`flex items-center gap-1 text-blue-600 hover:text-blue-800 hover:underline ${className}`}
      >
        {showIcon && <UserIcon className="w-3 h-3" />}
        <span>{username}</span>
      </button>

      <UserProfile
        userId={userId}
        username={username}
        isOpen={profileOpen}
        onClose={() => setProfileOpen(false)}
      />
    </>
  );
};

export default ClickableUser;